// src/modules/app-views/services/pages/Document/tabs/AiInfoTab/ServiceDataSection.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Descriptions, Collapse, Tag, theme } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { DEFAULT_OPEN_KEYS } from './index';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ServiceDataSection = ({ data, aiResponse, isMobile }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();
  const svc = aiResponse?.service;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const hasData = svc && (svc.name || svc.shortName || svc.description);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData) return null;

  return (
    <Collapse
      className="collapsed-content-fit"
      defaultActiveKey={DEFAULT_OPEN_KEYS.includes('service-data') ? ['service-data'] : []}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'service-data',
          label: (
            <Flex align="center" gap={8}>
              <FileTextOutlined style={{ color: token.colorPrimary }} />
              <span style={{ fontWeight: 600 }}>{translateX('service_data')}</span>
            </Flex>
          ),
          showArrow: false,
          children: (
            <Descriptions
              bordered
              size="small"
              column={1}
              layout={isMobile ? 'vertical' : 'horizontal'}
              styles={{ label: { fontWeight: 500 } }}
            >
              {svc.name && (
                <Descriptions.Item label={translateX('full_name')}>
                  {svc.name}
                </Descriptions.Item>
              )}
              {svc.shortName && (
                <Descriptions.Item label={translateX('short_name')}>
                  {svc.shortName}
                </Descriptions.Item>
              )}
              {svc.description && (
                <Descriptions.Item label={translateX('description')}>
                  {svc.description}
                </Descriptions.Item>
              )}
              {svc.searchKeywords?.length > 0 && (
                <Descriptions.Item label={translateX('keywords')}>
                  <Flex wrap="wrap" gap={4}>
                    {svc.searchKeywords.map((kw, idx) => (
                      <Tag key={idx} style={{ margin: 0 }}>{kw}</Tag>
                    ))}
                  </Flex>
                </Descriptions.Item>
              )}
            </Descriptions>
          ),
        },
      ]}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ServiceDataSection;
